import moment from 'moment'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import pepApi from 'services/api/pep'

function useElectronMessageListener() {
  const sessionId = useSelector(s => s.login.sessionId)
  const pms = useSelector(s => s.hotelDetails.pms)
  const isLoggedIn = useSelector(s => s.login.userLoggedIn)
  const currentHotelName = useSelector(s => s.login.currentHotel)

  useEffect(() => {
    window.checkReportsFromElectron = checkReportsFromElectron
  })

  function checkReportsFromElectron() {
    if (!window.electron) return false

    if (!isLoggedIn) {
      window.electron.postMessage({
        type: 'report-status',
        data: {
          status: 'not-logged-in'
        }
      })
      return false
    }

    if (isLoggedIn && !currentHotelName) {
      window.electron.postMessage({
        type: 'report-status',
        data: {
          status: 'no-hotel-selected'
        }
      })
      return false
    }

    if (!sessionId) {
      window.electron.postMessage({
        type: 'report-status',
        data: {
          status: 'no-session-id'
        }
      })
      return false
    }

    if (pms !== 'pep') {
      window.electron.postMessage({
        type: 'report-status',
        data: {
          status: 'PMS is not PEP'
        }
      })
      return false
    }

    pepApi.getActivity().then(res => {
      const startDate = res.startDate
      const endDate = res.endDate
      const dates = convertToDatesArray(res.activities)
      const missingDates = getDatesBetween(startDate, endDate).filter(
        date => !dates.includes(date)
      )
      window.electron.postMessage({
        type: 'report-status',
        data: {
          status: 'success',
          missingDates,
          startDate,
          endDate,
          pms,
          sessionId
        }
      })
      return true
    })
  }
}

function getDatesBetween(start, end) {
  const dates = []
  let currentDate = moment(start).startOf('day')
  const endDate = moment(end).startOf('day')

  while (currentDate <= endDate) {
    dates.push(currentDate.format('YYYY-MM-DD'))
    currentDate.add(1, 'days')
  }

  return dates
}

function convertToDatesArray(data) {
  const result = []

  for (const item of data) {
    const dates = getDatesBetween(item.startDate, item.endDate)
    result.push(...dates)
  }

  return result
}

export default useElectronMessageListener
